import React, { Component } from 'react';
import _HelpDeskAdminServices from '../../modules/HelpDeskAdminService';
import { Spin } from 'antd';
import {
    Tag,
    Input,
    Pagination
} from 'antd';
import _utils from '../../modules/Utils';
const { Search } = Input;


class CandidateListFromDB extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: { pageSize: 5, current: 1, total: 0 },
            data: [],
            loading: false,
            totalRowCount: 0,
            searchTerm: "",
            selectedRowKeys: [],
            filteredCandidatesDBList: [],
            studentListCheckbox: false
        };
    }

    getAllCandidates = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let candidateList = await _HelpDeskAdminServices.GetAllCandidatesFromDB(this.state.pagination.current, this.state.pagination.pageSize, this.state.searchTerm);
                    let searchedData = candidateList.data;

                    this.setState({
                        ...this.state,
                        data: searchedData.List,
                        totalRowCount: searchedData.TotalRecords,
                        pagination: { ...this.state.pagination, total: searchedData.TotalRecords },
                        loading: false,
                        studentListCheckbox: false
                    });

                } catch (e) {
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    handleClear = () => {
        console.log('handleClear()');
        this.setState({ searchTerm: "", data: [], studentListCheckbox: false });
        this.props.parentDataClearCallBack();
    };

    search = async () => {
        this.props.parentSearchCallBack();
        let stateSearch = this.state.searchTerm;
        console.log("search()")
        console.log("searchTerm++", stateSearch)

        if (stateSearch != "") {
            console.log("searchFromCandidateDB++")
            try {
                this.setState({ loading: true }, async () => {
                    try {
                        let candidateList = await _HelpDeskAdminServices.SearchCandidatesFromDB(this.state.pagination.current, this.state.pagination.pageSize, this.state.searchTerm);

                        let searchedData = candidateList.data;

                        this.setState({
                            ...this.state,
                            data: searchedData.List,
                            pagination: { ...this.state.pagination, total: searchedData.TotalRecords },
                            loading: false,
                            totalRowCount: searchedData.TotalRecords,
                            selectedRowKeys: [],
                            studentListCheckbox: false
                        });

                    } catch (e) {
                        this.setState({ loading: false });
                        console.log('Error: ', e);
                    }
                });
            } catch (e) { }
        } else {
            console.log("Else")
        }
    }

    onSearch = (value) => {
        console.log("onSearch()")
        this.setState({ searchTerm: value, pagination: { ...this.state.pagination, current: 1 } });
        this.search();
    }

    onSearchTextChange = ({ target: { name, value } }) => {
        console.log("onSearchTextChange()", value)
        this.setState({
            ...this.state,
            searchTerm: value
        });
    }

    onPageChange = (pageNumber) => {
        this.setState({ pagination: { ...this.state.pagination, current: pageNumber }, });
        this.search();
    }

    onShowSizeChange = (current, pageSize) => {
        this.setState({ pagination: { ...this.state.pagination, current: 1, pageSize: pageSize }, });
        this.search();
    };

    onHtmlSelectRow = studentID => {
        let dataList = this.state.data;
        let filteredList = dataList.filter((value) => value.Id == studentID)

        let tempKeys = this.state.selectedRowKeys;

        if (tempKeys.includes(studentID)) {
            this.setState({
                filteredCandidatesDBList: filteredList,
                selectedRowKeys: tempKeys.filter((value) => value != studentID), studentListCheckbox: false
            }, () => {
                // let checkboxSelected = false;
                this.props.parentCallback(filteredList, this.state.studentListCheckbox);
            })
        }
        else {
            tempKeys.push(studentID);
            this.setState({ selectedRowKeys: tempKeys, filteredCandidatesDBList: filteredList, studentListCheckbox: true }, () => {
                // let checkboxSelected = true;
                let showApproveButtonStatus = false;
                this.props.parentCallback(filteredList, this.state.studentListCheckbox, showApproveButtonStatus);
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        console.log("componentDidUpdate()")
        if (prevState.searchTerm !== '' && this.state.searchTerm === '') {
            this.handleClear();
        }
    }

    render() {

        if (this.state.loading)
            return <Spin size="large" />

        return ( <>

            <div className="pb-4 admin-custom-table">
                <h4 class="heading4 mt-3 ml-2">Registered Candidates Data</h4>
                <div className="pb-3 px-1">
                    <div className="search-wrap ">
                        <Search
                            placeholder="Search Application ID, First Name, Last Name, Email, Mobile No, Aadhaar No"
                            // allowClear
                            onSearch={this.onSearch}
                            value={this.state.searchTerm}
                            onChange={this.onSearchTextChange}
                            style={{
                                width: 460,
                                paddingLeft: '7px'
                            }}
                        />

                    </div>
                </div>

                
                <div className="custom-table-wrap  admin-table table-striped-rows">
                    <div className=" analysisWrap ant-table-small" >
                        <div className="ant-table-content">
                            <div className="ant-table-body">
                                <table className='customTable table-striped-rows whiteBg' id="myTable">
                                    <thead className="ant-table-thead"> 
                                        <tr className='stickyDiv'>
                                            <th className='h40' style={{ width: '3%' }}></th>
                                            <th className='h40' style={{ width: '8%' }}>Application ID</th>
                                            <th style={{ width: '20%' }}>Name</th>
                                            <th style={{ width: '9%' }}>Mobile No.</th>
                                            <th style={{ width: '13%' }}>Email</th>
                                            <th style={{ width: '9%' }}>Aadhaar No.</th>
                                            <th style={{ width: '10%' }}>Applied Post</th>
                                            <th style={{ width: '10%' }}>Transaction ID</th>
                                            <th style={{ width: '10%' }}>Trans. Date</th>
                                            <th style={{ width: '9%' }}>Submitted</th>
                                            <th style={{ width: '10%' }}>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody  className='ant-table-tbody '>
                                       
                                    {this.state.data.map((item, index) => (

                                        <tr data-index={index} key={item.Id}>
                                            <td><input
                                                disabled={this.state.selectedRowKeys && this.state.selectedRowKeys.length >= 1 && !this.state.selectedRowKeys.includes(item.Id) ? true : false}
                                                type="checkbox"
                                                className='customTableCellCheckbox'
                                                onClick={(enent) => this.onHtmlSelectRow(item.Id)}
                                                checked={this.state.selectedRowKeys.includes(item.Id)}
                                            /></td>
                                            <td>{item.Application_Id}</td>
                                            <td>{item.First_Name + ' ' + item.Middle_Name + ' ' + item.Last_Name}</td>
                                            <td>{item.Mobile_Number}</td>
                                            <td>{item.Email}</td>
                                            <td>{item.Aadhaar_Number}</td>
                                            <td style={{ lineHeight: '15px' }}>{item.Applied_Post}</td>
                                            <td>
                                                <label style={{
                                                    fontSize: '12px', textAlign: 'center',
                                                    backgroundColor: item.Challan_Transaction_Id == item.Submitted_Challan_Transaction_Id ? "var(--color-success-bg)" :
                                                        item.Submitted_Challan_Transaction_Id ? 'var(--color-error-bg)' : ""
                                                }}>
                                                    {item.Challan_Transaction_Id}
                                                </label>
                                            </td>
                                            <td>{item.Challan_Payment_Date ? _utils.convertToIndianDateFormat(item.Challan_Payment_Date) : <></>}</td>
                                            <td>{item.Is_Submitted == 1 ? "Submitted" : "Not Submitted"}</td>
                                            <td>
                                                {/* {item.Is_Submitted ?
                                                    <Tag style={{ fontSize: '10px', height: '25px', cursor: 'auto' }}
                                                        color={item.Is_Approved_Rejected == 0 ? "blue" : (item.Is_Approved_Rejected == 1 ? "green" : "red")}>
                                                        {item.Is_Approved_Rejected == 0 ? "Review" :
                                                            item.Roll_Number ? 'View' : (item.Is_Approved_Rejected == 1 ? "Approved" : "Rejected")}
                                                    </Tag> : <></>} */}
                                                {item.Is_Approved_Rejected == 1 ? "Approved" : (item.Is_Approved_Rejected == null || item.Is_Approved_Rejected == 0) ? "" : "Rejected"}
                                            </td>
                                        </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {!this.state.data.length ?
                                    <div className='text-center w-100 mt-4'><h3><strong className='text-info'>No Records</strong></h3></div>
                                    : ""}
                            </div>
                            <div className="ant-table-footer ">

                                    <div className="d-flex align-items-center justify-content-end">
                                        {this.state.selectedRowKeys.length ?
                                        <label style={{  marginRight: '20px', color: 'darkgreen' }}>Selected Records: {this.state.selectedRowKeys.length}</label>
                                        : <></>}
                                        <label style={{  marginRight: '20px' }}>Total Records: {this.state.totalRowCount}</label>        
                                    </div> 
                                
                            </div>
                        
                        </div>
                    </div>
                    {this.state.data.length ?
                        <>
                        <Pagination
                            showSizeChanger
                            pageSizeOptions={['5', '200', '300', '500', '1000']}
                            onShowSizeChange={this.onShowSizeChange}
                            onChange={this.onPageChange}
                            defaultCurrent={this.state.pagination.current}
                            total={this.state.pagination.total}
                            pageSize={this.state.pagination.pageSize}
                            className="ant-table-pagination mini"
                        />  
                    </>
                        : ""}
                        
                </div>     
                
            </div>
            </>
        )
    };
}

export default CandidateListFromDB;